import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Api } from './services/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  title = 'Best Price';
  currentDate: string;
  apiProgress: boolean = false;

  ngOnInit() {
    setInterval(() => {
      this.apiProgress = this.api.getApiStatus();
    }, 500);
    this.currentDate = localStorage.getItem('currDate');

    /* if (localStorage.getItem("token") != "") {
        this.ds.getMemberStatusCount(this.currentDate, this.currentDate).subscribe((res: any) => {
          if(res.code == "SUCCESS") {
             if (this.router.url == "/" || this.router.url == "/login") {
              this.router.navigateByUrl("/dashboard");
             }
          } else {
            this.router.navigateByUrl("/login");
          }
      });
    } else {
      this.router.navigateByUrl("/login");
    } */
  }

  constructor(private router: Router,
              public api: Api) {
  }

}
